"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from "react";
import { getAgent } from "./agent.js";
const COMPONENT_NAME = "AgentProviderClientComponent";
const AgentProviderContext = createContext(void 0);
const AgentProviderClientComponent = (props) => {
  const [agent, setAgent] = useState();
  useEffect(() => {
    if (typeof window !== "undefined") {
      setAgent(getAgent(props.environment));
    }
  }, [typeof window, props.environment]);
  return /* @__PURE__ */ jsx(
    AgentProviderContext.Provider,
    {
      value: {
        agent
      },
      children: props.children
    }
  );
};
const useAgent = () => {
  const context = useContext(AgentProviderContext);
  if (context === void 0) {
    throw new Error("useAgent must be used within an AgentProvider");
  }
  return context;
};
AgentProviderClientComponent.displayName = COMPONENT_NAME;
export {
  AgentProviderClientComponent,
  useAgent
};
